import request from './request';

const sanitizeParams = (params = {}) => {
  const result = { ...params };
  if (Object.prototype.hasOwnProperty.call(result, 'search')) {
    const searchValue =
      result.search === undefined || result.search === null
        ? ''
        : String(result.search).trim();
    if (!searchValue) {
      delete result.search;
    } else {
      result.search = searchValue;
    }
  }
  return result;
};

const shopService = {
  get: (params) =>
    request.get('dashboard/admin/shops', { params: sanitizeParams(params) }),
  getAll: (params) =>
    request.get('dashboard/admin/shops/paginate', {
      params: sanitizeParams(params),
    }),
  getById: (id, params) =>
    request.get(`dashboard/admin/shops/${id}`, { params }),
  create: (params) =>
    request.post('dashboard/admin/shops', {}, { params }),
  update: (id, params) =>
    request.put(`dashboard/admin/shops/${id}`, {}, { params }),
  setVerify: (uuid) => request.post(`dashboard/admin/shops/${uuid}/verify`, {}),
  delete: (params) =>
    request.delete(`dashboard/admin/shops/delete`, { params }),
  search: (params) =>
    request.get('dashboard/admin/shops/search', {
      params: sanitizeParams(params),
    }),
  getShopDeliveries: (params) =>
    request.get(`rest/shops/deliveries`, { params }),
  statusChange: (id, params) =>
    request.post(`dashboard/admin/shops/${id}/status/change`, {}, { params }),
  selectPaginate: (params) =>
    request
      .get('rest/shops/select-paginate', { params })
      .then((res) => res.data),

  dropAll: () => request.get(`dashboard/admin/shops/drop/all`),
  restoreAll: () => request.get(`dashboard/admin/shops/restore/all`),
};

export default shopService;
